import { render, staticRenderFns } from "./FollowUpBubbles.vue?vue&type=template&id=312c4798&scoped=true"
import script from "./FollowUpBubbles.vue?vue&type=script&lang=js"
export * from "./FollowUpBubbles.vue?vue&type=script&lang=js"
import style0 from "./FollowUpBubbles.vue?vue&type=style&index=0&id=312c4798&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312c4798",
  null
  
)

export default component.exports